<template>
  <div id="main" style="margin-left:5px; #margin-left:3px;">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <router-link to="/material">material</router-link> -->
    <div class="capTop">&nbsp;</div>
    <div id="content">
	<router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?3bbd961d